import React, { createContext, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, Typography } from "@mui/material";
import { Convert, ConvertMonthNameTH, DefaultArrayEmpty, FnAxios, FnDialog, I18n, formatNumber, getMonthDifference } from "utilities/utilities";
import InputNumberItem from "components/Input/InputNumber";
import { BtnAdd, BtnDelete } from "components/Button/ButtonAll";
import moment from "moment";
import DateRangeProject from "view/FrontEnd/Project/components/DateRange";
import { List as LINQ } from "linqts";

export default function WorkPlanProgressDuration(props) {
    const {
        nYear,
        form,
        onAdd,
        onDelete,
        arrDuration = [],
        lstProjectWorkPlan = [],
        isPermission,
        dStart,
        dEnd,
        trigger,
        nMixPlan,
        nProgressID,
    } = props;

    const DialogFn = FnDialog();
    const [nTrigger, setnTrigger] = useState(trigger);

    const handleChangeWeight = (nID) => {
        let _lstDuration = [];

        //#region เฉพาะกิจกรรม
        let nSum = 0;
        arrDuration.forEach(f => {
            // let nDiff = moment(form.getValues(`sEndMonth_${f.nID}`)).diff(moment(form.getValues(`sStartMonth_${f.nID}`)), "month");
            // let nWeight = 0;
            let _nWeight = form.getValues(`nWeight_${f.nID}`);
            // if (!isNaN(nDiff) && _nWeight) {
            //     nWeight = parseInt(_nWeight) * (nDiff + 1);
            // }
            // nSum += nWeight; //ปิดไว้เพราะไป + ข้างล่างแทน

            // ++ ปัญหาที่เจอล่าสุดคือ กรณีที่เลือกช่วงเดือนทีเดียว 3 เดือนกะว่าจะให้เพิ่มเดือนล่ะ 100 แต่ทีนี้มันไปจับ ว่า 300*3 เลย ผิด ต้องหาวิธี อาจจะต้องลองผิด การ * เดือนไปก่อน

            //#region ต้องหาวิธีที่จะบวกค่า กรณีที่ มีเดือนซ้ำกัน และ บวกเพิ่มของเดือนนั้นมาด้วย
            let dDateStart = moment(form.getValues(`sStartMonth_${f.nID}`)).year(nYear);
            let dDateEnd = moment(form.getValues(`sEndMonth_${f.nID}`)).year(nYear);
            let nMonthStart = parseInt(dDateStart.format("M"));
            let nMonthEnd = parseInt(dDateEnd.format("M"));
            _lstDuration.push({
                nID: f.nID,
                nMonthStart: nMonthStart,
                nMonthEnd: nMonthEnd,
                nWeight: _nWeight, //nWeight,
            });

            // if (f.nID !== nID) {
            //     let dAddStart = moment(form.getValues(`sStartMonth_${nID}`)).year(nYear);
            //     let dAddEnd = moment(form.getValues(`sEndMonth_${nID}`)).year(nYear);
            //     let nAddWeight = parseInt(form.getValues(`nWeight_${nID}`));
            //     let nAddMonthStart = parseInt(dAddStart.format("M"));
            //     let nAddMonthEnd = parseInt(dAddEnd.format("M"));
            //     let dStart = moment(form.getValues(`sStartMonth_${f.nID}`)).year(nYear);
            //     let dEnd = moment(form.getValues(`sEndMonth_${f.nID}`)).year(nYear);
            //     let nMonthStart = parseInt(dStart.format("M"));
            //     let nMonthEnd = parseInt(dEnd.format("M"));
            //     let isDup = false;
            //     //วันเริ่มอยู่ในช่วง
            //     if (dAddStart.isBetween(dStart, dEnd, "month", "[]")) isDup = true;
            //     //วันเสิ้นสุดอยู่ในช่วง
            //     if (dAddEnd.isBetween(dStart, dEnd, "month", "[]")) isDup = true;
            //     // //วันเริ่มในตารางอยู่ในช่วงวันที่เพิ่ม
            //     // if (dStart.isBetween(dAddStart, dAddEnd, "month", "[]")) isDup = true;
            //     // //วันสิ้นสุดในตารางอยู่ในช่วงวันที่เพิ่ม
            //     // if (dEnd.isBetween(dAddStart, dAddEnd, "month", "[]")) isDup = true;
            //     if (isDup === true) nSum += nAddWeight;
            // }
            //#endregion
        });
        //#endregion

        //#region ผลรวมทั้งหมด และต้องทีล่ะเดือน เพราะไม่มีค่าเก็บไว้ต้องหาใหม่เสมอ
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 1 && w.nMonthEnd >= 1).Sum(s => s.nWeight);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 2 && w.nMonthEnd >= 2).Sum(s => s.nWeight);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 3 && w.nMonthEnd >= 3).Sum(s => s.nWeight);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 4 && w.nMonthEnd >= 4).Sum(s => s.nWeight);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 5 && w.nMonthEnd >= 5).Sum(s => s.nWeight);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 6 && w.nMonthEnd >= 6).Sum(s => s.nWeight);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 7 && w.nMonthEnd >= 7).Sum(s => s.nWeight);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 8 && w.nMonthEnd >= 8).Sum(s => s.nWeight);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 9 && w.nMonthEnd >= 9).Sum(s => s.nWeight);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 10 && w.nMonthEnd >= 10).Sum(s => s.nWeight);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 11 && w.nMonthEnd >= 11).Sum(s => s.nWeight);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 12 && w.nMonthEnd >= 12).Sum(s => s.nWeight);
        //#endregion

        if (nSum > 100) {
            DialogFn.Warning("จำนวนผลรวมค่าน้ำหนักต่อเดือนเกิน 100.", () => { form.setValue(`nWeight_${nID}`, null); });
        }
        if (nSum > nMixPlan) {
            DialogFn.Warning("จำนวนผลรวมค่าน้ำหนักต่อเดือนเกิน ผลรวมของแผนค่าน้ำหนักทั้งหมด " + formatNumber(nMixPlan, 0) + " (ร้อยละ).", () => { form.setValue(`nWeight_${nID}`, null); });
        }
    }

    //// const OnCheckDuplicate = (date, clone) => {
    ////     let isDuplicate = false;
    ////     clone.forEach(item => {
    ////         let start = moment(form.getValues(`sStartMonth_${item.nID}`)).year(nYear);
    ////         let end = moment(form.getValues(`sEndMonth_${item.nID}`)).year(nYear);
    ////         if (start.isValid && end.isValid) {
    ////             let isBetween = date.isBetween(start, end, undefined, "[]");
    ////             if (isBetween) {
    ////                 isDuplicate = true;
    ////                 return true;
    ////             }
    ////         }
    ////     });
    ////     return isDuplicate;
    //// }

    const OnCheckDuplicate = (date, clone, nID) => {
        let isDuplicate = false;
        clone.forEach(item => {
            let start = moment(form.getValues(`sStartMonth_${item.nID}`)).year(nYear);
            let end = moment(form.getValues(`sEndMonth_${item.nID}`)).year(nYear);
            if (start.isValid() && end.isValid()) {
                // เริ่มต้น - สิ้นสุดของช่วงใหม่
                let newStart = moment(form.getValues("sStartMonth_" + nID)).year(nYear);
                let newEnd = moment(form.getValues("sEndMonth_" + nID)).year(nYear);
                // เงื่อนไขการทับซ้อนช่วง: ช่วงใหม่เริ่มก่อน end เดิม และสิ้นสุดหลัง start เดิม
                const isOverlap = newStart.isSameOrBefore(end) && newEnd.isSameOrAfter(start);
                if (isOverlap) {
                    isDuplicate = true;
                    return true;
                }
            }
        });
        return isDuplicate;
    };

    const handleOnChange = (e, nID, type) => {
        let isDuplicate = false;
        let clone = [...arrDuration].filter(f => f.nID !== nID);
        if (e) {
            let date = moment(e).year(nYear);
            isDuplicate = OnCheckDuplicate(date, clone, nID);
            handleChangeWeight(nID);
            if (isDuplicate) {
                DialogFn.Warning("ช่วงเวลาซ้ำ");
                if (type === "start") {
                    form.setValue(`sStartMonth_${nID}`, null);
                    // setSMin(null);
                } else {
                    form.setValue(`sEndMonth_${nID}`, null);
                    // setSMax(null);
                }
                //// setnTrigger(nTrigger + 1);
                setnTrigger(v => v + 1);
            }
        }
    }

    // const [sMin, setSMin] = useState(null);
    // const [sMax, setSMax] = useState(null);
    // const handleChangeStart = (event, nID, type) => {
    //     handleOnChange(event, nID, type);
    //     setSMin(event);
    // }
    // const handleChangeEnd = (event, nID, type) => {
    //     handleOnChange(event, nID, type);
    //     setSMax(event);
    // }

    //// console.log("nTrigger", nTrigger);
    //// console.log("dStart", dStart ? Convert.DateTimeToString(dStart, "DD MM YYYY") : null);
    //// console.log("dEnd", dEnd ? Convert.DateTimeToString(dEnd, "DD MM YYYY") : null);

    return (
        <Grid item xs={12} md={12} container spacing={2} style={{ padding: '1%', paddingBottom: '1%', }}>
            <FormProvider {...form}>
                <Grid item xs={12} md={12} container spacing={2} >
                    {(arrDuration || []).map((m, i) => {
                        return (
                            <Grid item container spacing={2} key={"key_duration_" + m.nID} style={{ display: (m.nProgressID !== nProgressID ? 'none' : ''), }}>
                                <Grid item xs={12} md={7}>
                                    <DateRangeProject
                                        NameStart={`sStartMonth_${m.nID}`}
                                        NameEnd={`sEndMonth_${m.nID}`}
                                        LabelStart={'เริ่มต้น'}
                                        LabelEnd={'สิ้นสุด'}
                                        nID={m.nID}
                                        //// required={true}
                                        required={m.nProgressID === nProgressID}
                                        nYearMapper={nYear}
                                        onChange={handleOnChange}
                                        minDate={dStart}
                                        maxDate={dEnd}
                                        nTrigger={nTrigger}
                                        disabled={!isPermission}
                                        form={form}
                                    />
                                    {/* <Grid item xs={12} md={12} container spacing={1} direction="row" alignItems="start">
                                        <Grid item xs={5.8}>
                                            <DatePickerItem
                                                id={`sStartMonth_${m.nID}`}
                                                name={`sStartMonth_${m.nID}`}
                                                label={'เริ่มต้น'}
                                                required={true}
                                                minDate={dStart}
                                                maxDate={sMax || dEnd}
                                                onChange={(e) => handleChangeStart(e, m.nID, "start")}
                                                disabled={!isPermission}
                                                defaultCalendarMonth={moment(dStart)}
                                            />
                                        </Grid>
                                        <Grid item style={{marginTop: '2%'}}> - </Grid>
                                        <Grid item xs={5.7}>
                                            <DatePickerItem
                                                id={`sEndMonth_${m.nID}`}
                                                name={`sEndMonth_${m.nID}`}
                                                label={'สิ้นสุด'}
                                                required={true}
                                                minDate={sMin || dStart}
                                                maxDate={dEnd}
                                                onChange={(e) => handleChangeEnd(e, m.nID, "end")}
                                                disabled={!isPermission}                   
                                                defaultCalendarMonth={moment(dStart)}
                                            />
                                        </Grid>
                                    </Grid> */}
                                </Grid>
                                <Grid item xs={6} md={3}>
                                    <InputNumberItem
                                        id={`nWeight_${m.nID}`}
                                        name={`nWeight_${m.nID}`}
                                        label={"ค่าน้ำหนักต่อเดือน"}
                                        endAdornment={"ร้อยละ"}
                                        type={"Number"}
                                        //// required={true}
                                        required={m.nProgressID === nProgressID}
                                        IsComma={true}
                                        IsAllowScientific={false}
                                        ShowDigits={0}
                                        maxDigits={0}
                                        maxInteger={3}
                                        min={0}
                                        max={nMixPlan}
                                        disabled={!isPermission}
                                        onChange={() => { handleChangeWeight(m.nID) }}
                                    />
                                </Grid>
                                {isPermission &&
                                    <Grid item xs={6} md={2}>
                                        <Grid container spacing={2}>
                                            {(arrDuration || []).length === i + 1 &&
                                                <Grid item>
                                                    <BtnAdd
                                                        sColor="#00B393"
                                                        sColorHover="#009278"
                                                        id={`AddDurationWorkPlan_${m.nID}`}
                                                        txt={'เพิ่มช่วงเวลา'}
                                                        IsCircleWithOutText
                                                        onClick={form.handleSubmit((e) => onAdd(m.nActivityID), (err) => {
                                                            document.getElementById(Object.keys(err)[0])?.focus();
                                                        })}
                                                    />
                                                </Grid>
                                            }
                                            {(arrDuration || []).filter(f => f.nProgressID === nProgressID).length > 1 &&
                                                <Grid item>
                                                    <BtnDelete
                                                        sColorHover="#d30d1e"
                                                        id={`DeleteDurationWorkPlan_${m.nID}`}
                                                        IsCircleWithOutText
                                                        onClick={() => onDelete(m.nID)}
                                                    />
                                                </Grid>
                                            }
                                        </Grid>
                                    </Grid>
                                }
                            </Grid>
                        )
                    })}
                </Grid>
                <Grid item style={{ display: 'none', }}>
                    {isPermission &&
                        <BtnAdd
                            id={"AddDurationWorkPlan"}
                            onClick={form.handleSubmit((e) => () => { }, (err) => {
                                document.getElementById(Object.keys(err)[0])?.focus();
                            })}
                        />
                    }
                </Grid>
            </FormProvider>
        </Grid>
    )
}